import Reflux from 'reflux';

const AuthenticationActions = Reflux.createActions({
  load: { asyncResult: true },
  update: { asyncResult: true },
});

export default AuthenticationActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/actions/authentication/AuthenticationActions.js